import { Link } from "react-router-dom";
import type { Product } from "../data/products";
import { formatGbp } from "../lib/money";
import { JewelleryMotif } from "./JewelleryMotif";

export function ProductTile({ product }: { product: Product }) {
  return (
    <Link className="product-tile" to={`/products/${product.slug}`}>
      <div className="vitrine">
        <JewelleryMotif motif={product.motif} title={product.name} />
      </div>
      <div className="product-copy">
        <h3>{product.name}</h3>
        <p className="muted">{product.summary}</p>
        <p className="price">{formatGbp(product.priceGbp)}</p>
      </div>
    </Link>
  );
}
